import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StartAProject() {
  return <section data-section-id="244139" id="begin-your-creation" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex flex-col items-center justify-center min-h-[70vh]">
      {}
      <div className="absolute inset-0 opacity-40 mix-blend-soft-light pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670658/img/diamond_facet_blur.png)] bg-cover bg-center" style={{
      filter: "blur(40px)",
      animation: "grain 12s ease-in-out infinite"
    }}>
        <style>
          {`
            @keyframes grain {
              0%, 100% { transform: scale(1) rotate(0deg); }
              33% { transform: scale(1.1) rotate(2deg); }
              66% { transform: scale(1.05) rotate(-1deg); }
            }
          `}
        </style>
      </div>

      {}
      <div className="container relative z-10 flex flex-col items-center px-4">
        <h2 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold text-center uppercase tracking-tighter leading-[0.9] mb-16 max-w-6xl text-primary">
          YOUR VISION, ENGINEERED TO PERFECTION.
        </h2>

        <Button asChild variant="outline" className="w-[90%] md:w-[40%] h-20 md:h-24 rounded-md border-2 border-secondary text-secondary text-xl md:text-2xl font-default font-bold uppercase tracking-widest transition-all duration-500 hover:bg-secondary hover:text-secondary-foreground hover:border-transparent hover:scale-105 hover:shadow-3xl relative overflow-hidden group">
          <Link to="/StartYourProjectPage">
            <span className="relative z-10">Request a Quote</span>
            <div className="absolute inset-0 bg-secondary/20 scale-0 group-hover:animate-ping rounded-md" />
          </Link>
        </Button>
      </div>
    </section>;
}